import styled, { css } from 'styled-components';
import { ProgressRing } from '../Icons/ProgressRing/index.js';
import { Button } from '../Buttons/ButtonV2/index.js';
import { BtnText, BtnIcon } from '../Buttons/ButtonV2/styles.js';
import { Card as Card$1 } from '../Card/index.js';

const cardPaddingInPx = 16;
const Card = styled(Card$1).withConfig({
    displayName: "styles__Card",
    componentId: "sc-9775c5db-0"
})`
    padding: ${cardPaddingInPx}px;
    position: relative;
    overflow: hidden;
    box-sizing: content-box;
    transition-duration: 300ms;
    margin-bottom: ${({ theme  })=>theme.spacers.M};

    ${({ height , theme , backgroundColor  })=>css`
        height: ${height ? `${height}px` : "auto"};
        background-color: ${backgroundColor ?? theme.colors.ElementBackground};
    `}

    ${(props)=>props.dismissed ? css`
                  border-color: transparent;
                  background-color: ${props.theme.colors["Level 1"]};
              ` : ""};

    &.dismissing-card-exit {
        opacity: 1;
    }

    &.dismissing-card-exit-active,
    &.dismissing-card-exit-done {
        opacity: 0;
    }
`;
const Content = styled.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-9775c5db-1"
})``;
const DismissingContainer = styled.div.withConfig({
    displayName: "styles__DismissingContainer",
    componentId: "sc-9775c5db-2"
})`
    ${(props)=>props.hasTimeout ? css`
                  display: flex;
                  align-items: center;
              ` : ""};
`;
const DismissedText = styled.p.withConfig({
    displayName: "styles__DismissedText",
    componentId: "sc-9775c5db-3"
})`
    flex: 1 1 auto;
    align-self: flex-start;
    color: ${(props)=>props.hasTimeout ? props.theme.colors["Level 4"] : props.theme.colors["Level 5"]};
    ${(props)=>css(props.theme.typography.Paragraph)};
    line-height: 32px;
`;
const UndoButton = styled(Button).withConfig({
    displayName: "styles__UndoButton",
    componentId: "sc-9775c5db-4"
})`
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 8px;

    ${BtnText} {
        line-height: 24px;
        color: ${(props)=>props.theme.colors["Level 5"]};
        ${(props)=>css(props.theme.typography.Paragraph)};
    }

    ${BtnIcon} {
        max-width: unset;
    }
`;
const CircleDismissButton = styled(Button).withConfig({
    displayName: "styles__CircleDismissButton",
    componentId: "sc-9775c5db-5"
})`
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 12px;
    padding: 0;
    min-width: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;

    ${(props)=>{
    var _props_$position, _props_$position1;
    return css`
        top: ${((_props_$position = props.$position) === null || _props_$position === void 0 ? void 0 : _props_$position.top) ?? cardPaddingInPx}px;
        right: ${((_props_$position1 = props.$position) === null || _props_$position1 === void 0 ? void 0 : _props_$position1.right) ?? cardPaddingInPx}px;
    `;
}}
`;
const TimerDismissButton = styled(Button).withConfig({
    displayName: "styles__TimerDismissButton",
    componentId: "sc-9775c5db-6"
})`
    width: 32px;
    height: 32px;
    border: 0;
    padding: 0;

    ${BtnIcon} {
        max-width: unset;
        margin: 0;
    }
`;
const TimerProgress = styled(ProgressRing).withConfig({
    displayName: "styles__TimerProgress",
    componentId: "sc-9775c5db-7"
})`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
`;
const ButtonsWrap = styled.div.withConfig({
    displayName: "styles__ButtonsWrap",
    componentId: "sc-9775c5db-8"
})`
    display: flex;
    margin-top: ${({ theme  })=>theme.spacers.XL};
`;
const ConfirmCancelButton = styled(Button).withConfig({
    displayName: "styles__ConfirmCancelButton",
    componentId: "sc-9775c5db-9"
})`
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 8px;

    ${BtnText} {
        line-height: 24px;
        color: ${({ theme  })=>theme.colors.negative};
        ${(props)=>css(props.theme.typography.Paragraph)};
    }

    ${BtnIcon} {
        max-width: unset;
    }
`;

export { ButtonsWrap, Card, CircleDismissButton, ConfirmCancelButton, Content, DismissedText, DismissingContainer, TimerDismissButton, TimerProgress, UndoButton };
